import { render, staticRenderFns } from "./NpaPromotionHistoryDocs.vue?vue&type=template&id=c7fdbbd8&scoped=true&"
import script from "./NpaPromotionHistoryDocs.vue?vue&type=script&lang=js&"
export * from "./NpaPromotionHistoryDocs.vue?vue&type=script&lang=js&"
import style0 from "./NpaPromotionHistoryDocs.vue?vue&type=style&index=0&id=c7fdbbd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fdbbd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VDialog,VFileInput,VForm,VIcon,VSelect})
